import examineList from './examineList.vue';
import allList from './allList.vue';
import { claimsList } from './request';
export default {
  components: {
    examineList,
    allList
  },
  data() {
    return {
      current: 1,
      num: 0
    };
  },
  created() {
    this.getNumFun();
  },
  methods: {
    getNumFun() {
      claimsList({
        page: 1,
        pageSize: 1,
        status: 'PENDING',
        type: 'checkPending'
      }).then(res => {
        this.num = res.totalNum;
      });
    }
  }
};